import { CricketIcon } from './CricketIcon';

/**
 * author: Google
 * id 9C7DBA7B-099C-460D-BD51-2B2F70EBE39A
 * name cricket
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cricket.svg
 * tags
 * - Sport 
 */
export const CricketBatIcon = CricketIcon;
export default CricketBatIcon